<template>
  <FormItem label="条件" prop="conditions">
    <div>
      <div style="color: #e91e63">
        只要满足一个条件就行
      </div>
      <div v-for="(item, index) in value" :key="index">
        <span style="color: #2196f3">条件{{ index + 1 }}：</span>
        <span v-for="(condition, i) in item" :key="i">
          {{ getConditionLabel(condition) }};
        </span>
        <Icon
          class="conditionIcon"
          color="#7f9fd5"
          type="ios-create-outline"
          @click="editCondition(index)"
        />
        <Icon
          class="conditionIcon"
          color="#ed4014"
          type="ios-trash-outline"
          @click="delCondition(index)"
        />
      </div>
      <Row>
        <Col span="22" offset="1">
          <Button type="dashed" long @click="addCondition" icon="md-add"
            >添加条件</Button
          >
        </Col>
      </Row>
    </div>
    <conditions-modal
      v-model="conditionVis"
      :curCondition="value[curConditionIndex]"
      @onCancel="closeConditionsModal"
      @onSubmit="saveConditions"
    />
  </FormItem>
</template>

<script>
import { mapState } from "vuex";
import ConditionsModal from "./ConditionsModal.vue";

export default {
	components: { ConditionsModal },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      curConditionIndex: -1,
      conditionVis: false,
      operator: {
        gt: "大于",
        lt: "小于",
        gte: "大于等于",
        lte: "小于等于",
        equals: "等于",
        all: "包含所有",
        any: "包含任一",
      },
    };
  },
	computed: {
    ...mapState("setting", ["sysVars"]),
    ...mapState('intents', [
      "intents", // 知识库
    ]),
  },
  methods: {
    getConditionLabel(condition) {
      const { rule = "", op, value } = condition;
      let varName = rule.split(":")[1];
      if (rule.indexOf("sys:") === 0) {
        const sysVar = this.sysVars.find((sysVar) => sysVar.id === varName);
        varName = sysVar?.name;
      } else if (rule.indexOf("intent") === 0) {
        const intentId = rule.slice(4);
        const intent = this.intents.find((intent) => intent.id === varName);
        varName = `${intent?.name || ""} 次数`;
      }
      return `${varName} ${this.operator[op]} ${value}`;
    },
    /**
     * 条件
     */
    // 添加条件
    addCondition() {
      this.curConditionIndex = -1;
      this.conditionVis = true;
    },
    // 编辑条件
    editCondition(index) {
      this.curConditionIndex = index;
      this.conditionVis = true;
    },
    // 删除条件
    delCondition(index) {
			const newVal = [...this.value]
      newVal.splice(index, 1);
			this.$emit('input', newVal)
    },
    // 关闭条件modal
    closeConditionsModal() {
      this.curConditionIndex = -1;
      this.conditionVis = false;
    },
    // 条件modal保存
    saveConditions(newCondition) {
      if (!newCondition || newCondition.length === 0) {
        if (this.curConditionIndex !== -1) {
          this.delCondition(this.curConditionIndex);
        }
        return;
      }
			const newVal = [...this.value]
      if (this.curConditionIndex !== -1) {
        newVal[this.curConditionIndex] = newCondition;
      } else {
				newVal.push(newCondition);
      }
			this.$emit('input', newVal)
    },
  },
};
</script>
